<template>
    <u-btn-text-fit-arrow v-bind="$attrs" color="white" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-btn-text-fit-arrow>
</template>

<script>
import UBtnTextFitArrow from "@/components/publish/styles/buttons/u-btn-text-fit-arrow.vue";

export default {
    props: {},
    components: {
        UBtnTextFitArrow,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
